var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Card',{staticClass:"well p-0 p-sm-5",class:{
        'py-md-4 py-lg-8': _vm.compact !== false,
        'gradient': !_vm.bgImage,
        'flush': _vm.flush,
    },style:({
        'background-image': _vm.bgImage && `url(${_vm.bgImage})`
    })},[_c('div',{staticClass:"well-container"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }